export default {
  title: 'Reserveringsservice bedrijf gedeactiveerd',
  description: 'De reserveringsservice is momenteel inactief voor dit bedrijf. U kunt deze activeren via Services.',
  button: {
    settings: 'Ga naar Instellingen',
  },
};
